import React, { useState, useEffect } from 'react';
import { MdNotificationsActive, MdClose } from 'react-icons/md';
import './ToastNotification.css';

let toastListener = null;

export const showToastNotification = (notification) => {
  if (toastListener) {
    toastListener(notification);
  }
};

const ToastNotification = ({ onNavigate }) => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    toastListener = (newNotification) => {
      const id = Date.now() + Math.random().toString(36).substring(2, 9);
      const toastItem = { id, ...newNotification };
      setToasts((prev) => [...prev.slice(-3), toastItem]); // keep max 4 recent toasts

      // Auto dismiss after 6 seconds
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 6000);
    };

    return () => {
      toastListener = null;
    };
  }, []);

  const handleDismiss = (e, id) => {
    e.stopPropagation();
    setToasts((prev) => prev.filter((t) => t.id !== id));
  };

  const handleToastClick = (toast) => {
    if (toast.onClick) {
      toast.onClick();
    } else if (toast.threadId && onNavigate) {
      onNavigate('/tenant/messages', { state: { threadId: toast.threadId } });
    }
    setToasts((prev) => prev.filter((t) => t.id !== toast.id));
  };

  if (toasts.length === 0) return null;

  return (
    <div className="toast-notification-container" role="status" aria-live="polite">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="toast-notification-card"
          onClick={() => handleToastClick(toast)}
        >
          <MdNotificationsActive className="toast-icon" />
          <div className="toast-body">
            <div className="toast-title">{toast.title || 'Notification'}</div>
            {toast.body && <div className="toast-message">{toast.body}</div>}
          </div>
          <button
            type="button"
            className="toast-close-btn"
            onClick={(e) => handleDismiss(e, toast.id)}
            aria-label="Close notification"
          >
            <MdClose />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastNotification;
